/*
 * @Date: 2020-03-17 11:35:14
 * @LastEditors: yuanjianlong@aixuexi.com
 * @LastEditTime: 2020-04-03 18:59:21
 * @FilePath: \st-teacher-2020\src\service\common\index.ts
 */
import fetch from '../fetch';
import url from './common-url';

export default {
  // 获取管理员列表
  getAdminList() {
    return fetch({
      url: url.getAdminList,
      method: 'get',
    });
  },
  // 权限判断
  getXiaoheAuth() {
    return fetch({
      url: url.getXiaoheAuth,
      method: 'get',
    });
  },
  // 空接口，每5分钟轮询一下接口，防止用户信息被盗用
  maintainLogin() {
    // @mock
    // console.log('@mock, maintainLogin:', '');
    return Promise.resolve('');
    // return fetch({
    //   url: url.maintainLogin,
    //   method: 'get',
    // });
  },
  getOption(params: object) {
    return fetch({
      url: url.getOption,
      method: 'get',
      params,
    });
  },
  saveOption(params: object) {
    return fetch({
      url: url.saveOption,
      method: 'get',
      params,
    });
  },
  getStorageSignature() {
    return fetch({
      url: url.getStorageSignature,
      method: 'get',
    });
  },
  // 调研问卷
  getQuestionnaire(params: object) {
    return fetch({
      url: url.getQuestionnaire,
      method: 'get',
      params,
    });
  },
  // 调研问卷
  submitQuestionnaire(data: object) {
    return fetch({
      url: url.submitQuestionnaire,
      method: 'post',
      data,
    });
  },
};
